import React, { Fragment, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";
import { connect } from "react-redux";

import MakeAPICall from "../../apiCalls/common";
import appRoutes from "../../routes/appRoutes";

import { addForumPostApiRoute } from "../../apiRoutes";

import Loader from "../../components/loader";
import CustomModal from "../../components/customModal";
import Label from "../../components/label";

import CreatePostForm from "../../containers/Forum/createPostForm";

import ICNoImg from "../../assets/images/default-picture.png";

const CreatePost = props => {
  let history = useHistory();

  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [modalText, setModalText] = useState("");
  const [showTextModal, setShowTextModal] = useState(false);

  const user = props.user ? props.user.userData : null;

  const onCreatePostFormSubmit = values => {
    let formData = new FormData();
    formData.append("topic", values.topic);
    formData.append("message", values.message);
    formData.append("tags", values.tags);
    formData.append("userId", user ? user._id : "");
    formData.append("userType", "Doctor");

    setIsProcessing(true);

    setApiCallParams({
      reqType: "POST",
      reqURL: addForumPostApiRoute,
      headers: {},
      dataObj: formData,
      params: {},
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Post Published Successfully");
        setShowTextModal(true);
        history.push(appRoutes.viewForum);
      },
      failureCallback: err => {
        console.log(err);
        setIsProcessing(false);
      },
      showPopUp: false
    });
  };

  return (
    <Fragment>
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="p-4 forum-create-post-container">
          <CustomModal
            useOneButton={true}
            cancelText="OKAY"
            openModal={showTextModal}
            cancelEvent={() => {
              setShowTextModal(false);
              setModalText("");
            }}
            modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
          />
          <NavLink
            to={appRoutes.viewForum}
            className="insta-link-orange font-15 text-decoration-none"
            href="#"
          >
            <i className="fas fa-arrow-left"></i>{" "}
            <span className="ml-1 back-btn-text"> Back to Forum</span>
          </NavLink>
          <div className="d-flex flex-row flex-wrap justify-content-between align-items-center mt-2">
            <Label title="Post New Topic" className="big" />
            <div className="d-flex flex-column justify-content-center align-items-center">
              <img
                className="rounded-circle user-pic"
                src={
                  user !== null &&
                  user.profilePic !== null &&
                  user.profilePic !== undefined
                    ? user.profilePic.original
                    : ICNoImg
                }
                alt="user-pic"
              />
              <p className="user-name">
                Dr {user ? user.firstName : ""} {user ? user.lastName : ""}
              </p>
            </div>
          </div>
          <CreatePostForm onFormSubmit={onCreatePostFormSubmit} />
          <br />
        </div>
      </div>
      {/* API Call */}
      <MakeAPICall apiParam={apiCallParams} />
    </Fragment>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user
});

export default connect(mapStateToProps, null)(CreatePost);
